<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/9/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为提高人力资源服务质量水平，促进人才服务工作高质量发展，根据《武侯区创建区域创新人才高地特色区的若干政策措施》，制定本细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/9/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            武侯区重点产业领域重点企业。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/9/title2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.2rem">
              （一）人才开发券用于购买人才招聘、培训测评、人力资源管理咨询、人力资源服务外包等人力资源服务产品。
            </div>
            <div class="des" style="margin-top: 0.2rem">
              （二）重点企业申请人才开发券应主动明确用途，对人力资源服务产品需求的有效期限。
            </div>
            <div class="des" style="margin-top: 0.2rem">
              （三）为重点企业提供人力资源服务产品的经营性人力资源服务机构应取得人力资源服务许可证或备案证1年以上，与服务对象企业无关联性，经营规范，依法在武侯区履行纳税或统计义务，按时完成年度报告，工商注册、税务登记和统计关系原则上均应在武侯区，无重大违规违法行为和严重失信行为。
            </div>
          </div>
        </div>

        <div class="part-four">
          <img
            src="../../assets/imgs/wuhou/1/title3.png"
            class="part-two-title-img"
          />
          <div class="main-content" style="padding-top: 0.2rem">
            <div
              style="
                font-size: 0.26rem;
                color: #4e4e4e;
                margin-bottom: 0.8rem;
                text-align: left;
                line-height:0.44rem;
              "
            >
              区人社局根据重点企业人力资源服务需求及需求周期确定人才开发券的使用类别及有效期，按照重点企业购买人力资源服务产品经费总额的50%发放最高不超过10万元的票券。
            </div>
            <div class="part-four-items">
              <div class="title-bg">申请</div>
              <div class="part-four-content1">
                区人社局每年定期制发通知，符合领取条件的重点企业，按照属地管理和行业归口的原则，向所属行业主管部门或街道提出购买申请等要件。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">初审</div>
              </div>
              <div class="part-four-content1">
                街道、行业主管部门（产业园区）负责对重点企业申报材料进行初审，出具初审意见。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">复审</div>
              <div class="part-four-content1">
                区人社局对申报材料进行复审，审核通过名单报区人社局党组审定。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg4">公示</div>
              <div class="part-four-content1">
                区人社局审定的结果公示5个工作日以上。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg5">发放</div>
              <div class="part-four-content1">
                对公示无异议的，区人社局向重点企业发放人才开发券。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg6">兑换</div>
              <div class="part-four-content1">
                提供人力资源服务产品的机构于服务期满后，持人才开发券及相关材料，向区人社局申请票券兑付。
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/1/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85176231">028-85176231</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
